import React, { useEffect, useState } from "react";
import ApexCharts from "apexcharts";
import jsonData from "../../../../current-survey-numeric.json";
import { FILTER_CONFIG } from "../../../../config/filterconfig"; // Import centralized filter config

const D01BarChartViz07 = ({ filterCriteria }) => {
  const [categories, setCategories] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    const demcat07Order = [
      "Female",
      "Male",
      "Non-Binary/Unspecified",
      "No Response",
    ];
    // Helper function to map filter keys to JSON keys
    const getJsonKey = (filterKey) => {
      const config = FILTER_CONFIG.find((item) => item.fieldName === filterKey);
      return config ? config.jsonKey : filterKey; // Default to the key if no mapping is found
    };

    // Apply filtering logic based on `filterCriteria`
    const filterData = (item) => {
      return Object.keys(filterCriteria).every((key) => {
        const jsonKey = getJsonKey(key); // Map filter key to JSON field
        if (filterCriteria[key].length === 0) {
          return true; // If no filter is selected, include all items
        }
        return filterCriteria[key].includes(item[jsonKey]);
      });
    };

    // Filter data using the filter criteria
    const filteredData = jsonData.filter(filterData);

    // Aggregate data by exempt status (demographic_category_07 in the new JSON)
    const demcat07Counts = filteredData.reduce((acc, item) => {
      const demcat07 = item.demographic_category_07; // Use demographic_category_07 for Work Status
      if (!acc[demcat07]) {
        acc[demcat07] = 0;
      }
      acc[demcat07]++;
      return acc;
    }, {});
    const sorteddemcat07Data = demcat07Order.map((demcat07) => ({
      demcat07,
      count: demcat07Counts[demcat07] || 0,
    }));

    const demcat07Names = sorteddemcat07Data.map((item) => item.demcat07);
    const chartData = sorteddemcat07Data.map((item) => item.count);
    // Update state
    setCategories(demcat07Names);
    setData(chartData);

    // Chart height calculation
    const barHeight = 25;
    const minBars = 10;
    const chartHeight = Math.max(
      barHeight * demcat07Names.length,
      barHeight * minBars
    );

    // Chart options
    const optionsViz07 = {
      series: [
        {
          name: "Count",
          data: chartData,
        },
      ],
      colors: ["#004983"],
      chart: {
        type: "bar",
        height: chartHeight,
        width: "95%",
      },
      legend: {
        show: false,
      },
      plotOptions: {
        bar: {
          borderRadius: 4,
          borderRadiusApplication: "end",
          horizontal: true,
          distributed: false,
          dataLabels: {
            position: "top",
          },
        },
      },
      dataLabels: {
        enabled: true,
        offsetX: 28, // Move labels off the bars
        style: {
          colors: ["#000"], // Set data labels to black
        },
        dropShadow: {
          enabled: true,
          top: 0,
          left: 0,
          blur: 2.5,
          color: "#fff",
          opacity: 1,
        },
      },
      xaxis: {
        categories: demcat07Names,
      },
    };

    // Render the chart
    const viz07 = new ApexCharts(
      document.querySelector("#viz-07"),
      optionsViz07
    );
    viz07.render();

    // Cleanup chart on component unmount
    return () => {
      viz07.destroy();
    };
  }, [filterCriteria]);

  return (
    <div style={{ width: "100%", overflowY: "auto" }}>
      <div id="viz-07"></div>
    </div>
  );
};

export default D01BarChartViz07;
